import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/features/auth/AuthContext";
import LoginPage from "@/features/auth/LoginPage";
import AdminLayout from "@/features/admin/AdminLayout";
import OverviewPage from "@/features/admin/OverviewPage";
import EvaluationsPage from "@/features/admin/EvaluationsPage";
import EvaluationDetailPage from "@/features/admin/EvaluationDetailPage";
import CreateEvaluationWizard from "@/features/admin/CreateEvaluationWizard";
import EvaluatorsPage from "@/features/admin/EvaluatorsPage";
import ResultsPage from "@/features/results/ResultsPage";
import ExportsPage from "@/features/exports/ExportsPage";
import EvaluatorApp from "@/features/evaluator/EvaluatorApp";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Navigate to="/admin" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<OverviewPage />} />
            <Route path="evaluations" element={<EvaluationsPage />} />
            <Route path="evaluations/new" element={<CreateEvaluationWizard />} />
            <Route path="evaluations/:id/setup" element={<CreateEvaluationWizard />} />
            <Route path="evaluations/:id" element={<EvaluationDetailPage />} />
            <Route path="evaluators" element={<EvaluatorsPage />} />
            <Route path="results" element={<ResultsPage />} />
            <Route path="exports" element={<ExportsPage />} />
          </Route>
          <Route path="/e/:token/*" element={<EvaluatorApp />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
        <Toaster position="bottom-right" richColors closeButton />
      </AuthProvider>
    </BrowserRouter>
  );
}
